import { Stack, Checkbox, Box } from '@machobear/design-system'
import { prop, ascend } from 'ramda'
import { useField, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { Dropdown } from '@/components/ds-form'

type Props = {
  name: string
  id: string
  label: string
  products: Product[]
  dropDownLabel: string
  onChange?: (a: boolean) => void
  trackingId: string
  disabled?: boolean
}
type Product = {
  billing_period: string
  currency: string
  item_name: string
  metadata: {
    platform: string
  }
  model_name: string
  name: string
  period_end_date: string
  period_start_date: string
  priceId: string
  quantity: number
  type: string
  value: string
}
const CheckboxWithOptions = ({
  name,
  id,
  label,
  products = [],
  dropDownLabel,
  onChange,
  disabled = false,
  trackingId
}: Props) => {
  const { t } = useTranslation()
  const { setFieldValue } = useFormikContext()
  const [field, meta, helpers] = useField(name)

  const { value } = field
  const isChecked = value.includes(id)

  const formattedProducts = products.sort(ascend(prop('quantity')))?.map((product: any) => {
    return {
      value: product?.priceId,
      label: t('l.syndication.inputs_monthstext', {
        defaultValue: '{{count}} month',
        defaultValue_plural: '{{count}} months',
        count: product?.quantity
      }),
      tertiaryLabel: t('l.syndication.checkbox_tertiary_label.text', {
        defaultValue: '${{price}} / {{count}} credit',
        defaultValue_plural: '${{price}} / {{count}} credits',
        price: product?.value,
        count: product?.quantity
      }),

      quantity: product?.quantity
    }
  })

  const productFieldName = `${id}Product`
  const [productField, productMeta, productHelpers] = useField(productFieldName)

  return (
    <Stack space="xsmall">
      <Checkbox
        id={trackingId}
        name={name}
        label={label}
        checked={isChecked}
        disabled={disabled}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const isChecked = e?.target?.checked
          const updatedPlatforms = isChecked
            ? value.concat(id)
            : value.filter((platform: string) => platform !== id)
          setFieldValue(name, updatedPlatforms)
          onChange?.(isChecked)
          if (isChecked && productField.value === undefined) {
            setFieldValue(productFieldName, formattedProducts?.[0]?.value, false)
          } else if (!isChecked) {
            setFieldValue(productFieldName, undefined, false)
          }
          productHelpers?.setTouched(true, false)
          helpers?.setTouched(true, false)
        }}
        tone={meta?.error ? 'critical' : 'neutral'}
      />
      <Box marginLeft="large">
        {isChecked && (
          <Dropdown
            name={productFieldName}
            label={dropDownLabel}
            required
            options={formattedProducts}
            searchable={false}
          />
        )}
      </Box>
    </Stack>
  )
}

export default CheckboxWithOptions
